// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1F1uC","text":"SelectPayment_text__MulvY","title":"SelectPayment_title__11NWi","btn":"SelectPayment_btn__35dKZ"};